<button (click)="makeReport()">Export</button>
<p-toast></p-toast>
<div class="menu-container">
    <div [formGroup]="searchForm">
        From:
        <p-calendar formControlName="from" [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange" dateFormat="dd/mm/yy"
        ></p-calendar>
        To:
        <p-calendar formControlName="to" [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange" dateFormat="dd/mm/yy"
        ></p-calendar>
        <button (click)="searchByRange()" [disabled]="searchForm.invalid">Search payments</button>
    </div>
</div>
<p-table [value]="payments">
    <ng-template pTemplate="header">
        <tr>
            <th>ID</th>
            <th>First name</th>
            <th>Last name</th>
            <th>Amount</th>
            <th>Currency</th>
            <th>Value in EUR</th>
            <th>Type</th>
            <th>Date</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-payment>
        <tr>
            <td>{{payment.bookingId}}</td>
            <td>
                <a routerLink="/management/edit-booking/{{payment.bookingId}}">
                    {{payment.studentFirstName}}
                </a>
            </td>
            <td>
                <a routerLink="/management/edit-booking/{{payment.bookingId}}">
                    {{payment.studentLastName}}
                </a>
            </td>
            <td>{{payment.amount}}</td>
            <td>{{payment.currency.isoCode}}</td>
            <td>{{payment.amountInEuro}}</td>
            <td>{{payment.paymentType.name}}</td>
            <td>{{payment.date | date: 'dd/MM/yyyy'}}</td>
        </tr>
    </ng-template>
</p-table>
